import { normalizeSigningPassword } from '@/utils/passwordPolicy';

export default {
  data() {
    return { signingInputErrors: {} };
  },
  methods: {
    signingInputError(field) {
      return this.signingRole && this.signingInputErrors[field]
        ? [this.$i18n.t('signingPasswordError')] : [];
    },
    signingBeforeInput(event, field) {
      if (!this.signingRole || !event.data) return;
      const input = event.target;
      const length = input.value.length - (input.selectionEnd - input.selectionStart);
      if (/[^0-9]/.test(event.data) || length + event.data.length > 4) {
        event.preventDefault();
        this.$set(this.signingInputErrors, field, true);
      } else {
        this.$set(this.signingInputErrors, field, false);
      }
    },
    signingPaste(event, field) {
      if (!this.signingRole) return;
      const value = event.clipboardData.getData('text');
      const input = event.target;
      if (/[^0-9]/.test(value) || input.value.length - (input.selectionEnd - input.selectionStart) + value.length > 4) {
        event.preventDefault();
        this.$set(this.signingInputErrors, field, true);
      }
    },
    signingInput(event, field) {
      if (!this.signingRole) return;
      const original = event.target.value;
      const value = normalizeSigningPassword(original);
      event.target.value = value;
      this.$set(this.signingInputErrors, field, original !== value);
    },
  },
};